import { getUserTimezone } from 'app/pages/meetings/utils';
import { Gap } from 'lib/components/styles/layout';
import {
  ParagraphNormal,
  ParagraphSmall,
} from 'lib/components/styles/typography';
import { useAuth } from 'lib/context/auth';
import React from 'react';
import { Tooltip, useCovideoTheme } from 'react-covideo-common';
import { MdInfo } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import { MAX_EMAIL_RECIPIENTS } from '../const';

export const EmailCount = ({ emailLimit }: { emailLimit: number }) => {
  const { t } = useTranslation();
  const {
    userData: { timezone, customer },
  } = useAuth();
  const emailsSentLimit = customer.emailsSentLimit || MAX_EMAIL_RECIPIENTS;
  const isLimitExceeded = emailLimit >= emailsSentLimit;
  const theme = useCovideoTheme();
  const color = isLimitExceeded
    ? theme.colors.danger[100]
    : theme.colors.black[80];

  const tz = getUserTimezone(undefined, timezone);

  return (
    <ParagraphSmall color={color} style={{ marginBottom: 8 }}>
      <Gap gap='4px' justifyContent='center' alignItems='center'>
        <strong> {t('Your daily limit:')}</strong> {`${emailLimit}`}/
        {`${emailsSentLimit}`}
        <Tooltip
          position='right'
          extendStyles={{
            popup: {
              width: '380px',
            },
          }}
          popup={
            <div>
              <ParagraphNormal color='inherit'>
                {t(
                  'Your daily limit of emails you can send. If you reach your daily maximum you will not be able to sent more email.'
                )}
                <strong>
                  {' '}
                  {t(
                    'Daily limit will restart each day at {{timezone}} time.',
                    { timezone: tz?.label || '' }
                  )}
                </strong>
              </ParagraphNormal>
            </div>
          }
        >
          <Gap justifyContent='center' alignItems='center'>
            <MdInfo
              color={theme.colors.neutral[80]}
              size={18}
              style={{ cursor: 'pointer' }}
            />
          </Gap>
        </Tooltip>
      </Gap>
    </ParagraphSmall>
  );
};
